import { render, staticRenderFns } from "./by-phone-confirmation.vue?vue&type=template&id=3b94fca5"
import script from "./by-phone-confirmation.vue?vue&type=script&lang=js"
export * from "./by-phone-confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-phone-confirmation.vue
// module id = 1qU4
// module chunks = 0